import formatDateTime from "./formatDateTime";
import parseDate from "./parseDate";

const renderDateTimeNoTimezone = (value: unknown) => {
  const valueNoTimezone = `${value}`.replace("Z", "");
  const dateValue = parseDate(valueNoTimezone);

  if (!dateValue) {
    return "-";
  }

  return formatDateTime(dateValue);
};

export default renderDateTimeNoTimezone;
